import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useState } from "react";
import { MainInput, main_button } from "./Styles";
import { useTranslation } from "react-i18next";

const PasswordVerificationModal = ({ 
  open, 
  onClose, 
  onVerify, 
  isLoading = false,
  title,
  message,
}) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const modalTitle = title ?? t("modals.passwordVerification");
  const modalMessage = message ?? t("modals.passwordVerificationMessage");

  const handleClose = () => {
    setPassword("");
    onClose();
  };

  const handleVerify = () => {
    if (password.trim()) {
      onVerify(password);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && password.trim()) {
      handleVerify();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={{ 
        "& .MuiDialog-paper": {
          backgroundColor: "var(--appBg)",
          color: "var(--secColor4)"
        }
      }}
    >
      <DialogTitle sx={{ backgroundColor: "var(--appBg)", color: "var(--secColor4)" }}>
        <Typography variant="h6" sx={{ color: "var(--secColor4)" }}>
          {modalTitle}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "var(--appBg)", color: "var(--secColor4)" }}>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" sx={{ color: "var(--secColor4)", mb: 2 }}>
            {modalMessage}
          </Typography>
          <MainInput
            margin="normal"
            fullWidth
            label={t("auth.password")}
            type="password"
            required
            value={password}
            onChange={({ target }) => setPassword(target.value)}
            onKeyPress={handleKeyPress}
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1, backgroundColor: "var(--appBg)" }}>
        <Button 
          onClick={handleClose} 
          sx={{ color: "var(--secColor4)" }}
          disabled={isLoading}
        >
          {t("common.cancel")}
        </Button>
        <Button
          onClick={handleVerify}
          sx={{ ...main_button }}
          disabled={!password.trim() || isLoading}
        >
          {isLoading ? t("modals.verifying") : t("modals.verify")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordVerificationModal;
